import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2e985422"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "佰特编码Wiki", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.lcbait.com",
  target: "_blank"
}, "视频教程", -1))
const _hoisted_4 = {
  key: 0,
  class: "login-menu color-blue"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "login-menu"
}
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!

  return (_openBlock(), _createBlock(_component_a_layout_header, {
    class: "header",
    style: { position: 'fixed', zIndex: 1000, width: '100%', margin: '0 0 0 0' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpClick && _ctx.jumpClick(...args)))
      }, _hoisted_2),
      _createVNode(_component_a_menu, {
        theme: "light",
        mode: "horizontal",
        style: { lineHeight: '64px' },
        defaultSelectedKeys: [_ctx.$route.path],
        selectedKeys: [_ctx.$route.path]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu_item, { key: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, { key: "/track" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/track" }, {
                default: _withCtx(() => [
                  _createTextVNode("学习路径")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, { key: "/video" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, { key: "/about" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/about" }, {
                default: _withCtx(() => [
                  _createTextVNode("关于我们")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.user.id)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/admin/user" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/user" }, {
                    default: _withCtx(() => [
                      _createTextVNode("用户管理")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.id)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/admin/ebook" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/ebook" }, {
                    default: _withCtx(() => [
                      _createTextVNode("电子书管理")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.id)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/admin/category" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/category" }, {
                    default: _withCtx(() => [
                      _createTextVNode("分类管理")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.id)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/admin/track" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/track" }, {
                    default: _withCtx(() => [
                      _createTextVNode("路径管理")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.user.id)
            ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/admin/statistic" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/statistic" }, {
                    default: _withCtx(() => [
                      _createTextVNode("数据统计")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_layout, { style: {"position":"absolute","right":"20px","display":"inline-block","background":"transparent"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_popconfirm, {
                title: "确认退出登录?",
                "ok-text": "是",
                "cancel-text": "否",
                onConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
              }, {
                default: _withCtx(() => [
                  (_ctx.user.id)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.user.id)
                ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                    _createElementVNode("span", null, "您好：" + _toDisplayString(_ctx.user.name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "color-blue"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("登录")
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["defaultSelectedKeys", "selectedKeys"])
    ]),
    _: 1
  }))
}